// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"218":"component---src-pages-404-tsx","691":"component---src-pages-index-tsx"}[chunkId] || chunkId) + "-" + {"36":"2f3d84b83187bf1b29a1","218":"8ca6b3946c0778d54097","691":"368af3e350071e8cbc40","698":"a50b0f32d2e385f666fd"}[chunkId] + ".js";
};